module.exports = __webpack_public_path__ + "static/media/p2_img3.e6590116.png";